import { Autocomplete, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { InternalUser } from "../../../types/app";
import _ from "lodash";

interface IProps {
  clientCultivators: InternalUser[];
  setClientCultivators: (internalUsers: InternalUser[]) => void;
  label: string;
  size?: "small" | "medium";
}

export default function ClientCultivatorsAutocomplete({ clientCultivators, setClientCultivators, label, size }: IProps) {
  const [clientCultivatorOptions, setClientCultivatorOptions] = useState<InternalUser[]>([]);

  useEffect(() => {
    const getClientCultivatorOptions = async () => {
      const { data } = await axios.get<InternalUser[]>(`/api/clientphonebook/internalUsers/getClientCultivators`);
      const missingSelectedCultivators = clientCultivators.filter(
        (clientCultivator) => !data.some((item) => item.id === clientCultivator.id)
      );
      const options = _.uniqBy([...missingSelectedCultivators, ...data], (option) => option.id);
      setClientCultivatorOptions(options);
    };

    getClientCultivatorOptions();
  }, [clientCultivators]);

  return (
    <Autocomplete
      multiple
      onChange={(_, options) => setClientCultivators(options)}
      options={clientCultivatorOptions}
      value={clientCultivators}
      fullWidth
      size={size || "medium"}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          inputProps={{
            ...params.inputProps,
            autoComplete: "new-password"
          }}
          fullWidth
          label={label}
          //   onChange={(e) => {
          //     setEditedRep(e.target.value);
          //   }}
        />
      )}
      getOptionLabel={(option) => (option?.firstName || "") + " " + (option?.lastName || "")}
    />
  );
}
